import { SPDownloadButton } from 'components/base/DownloadButton'
import { Fragment, createRef, useEffect, useRef } from 'react'
import { getGTM } from 'utils/functions'
import { WhatIsThisPointButton } from '../../base/WhatIsThisPointButton.tsx'
import { ROUTE_PATHS } from 'utils/constant.ts'

type Props = {
  isPointPage?: boolean
}

export function SPPointContact({ isPointPage = false }: Props) {
  const oldScroll = useRef<number>(0)

  const container = createRef<HTMLDivElement>()
  const timeout = useRef<any>(null)

  const onScroll = () => {
    if (container.current) {
      const { scrollY } = window

      if (Math.abs(scrollY - oldScroll.current) < 20) return

      container.current?.setAttribute('data-visible', 'false')
      container.current?.setAttribute('data-blur', String(scrollY > 100))

      if (timeout.current) {
        clearTimeout(timeout.current)
      }

      timeout.current = setTimeout(() => {
        container.current?.setAttribute('data-visible', 'true')
      }, 400)

      oldScroll.current = scrollY
    }
  }

  useEffect(() => {
    container.current?.setAttribute('data-blur', String(window.scrollY > 100))
    window.addEventListener('scroll', onScroll)
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  const downloadLink = isPointPage
    ? 'https://comado.go.link/fTLMa'
    : 'https://comado.go.link/2FYsL'

  const downloadGTM = {
    event_name: 'download_click',
    content_type: isPointPage ? 'Point' : 'TOP',
    content_id: 'FV_DL',
  }

  return (
    <Fragment>
      <div
        ref={container}
        data-visible='true'
        data-blur='false'
        className='fixed w-full z-50 bottom-0 p-[16px]'
      >
        <div className='flex flex-col max-w-[360px] w-full mx-auto'>
          <div className='grid grid-cols-2 gap-[8px]'>
            <a
              href={ROUTE_PATHS.POINT}
              {...getGTM({
                event_name: 'button_click',
                content_type: 'TOP_Point',
                content_id: 'ポイントとは',
              })}
            >
              <WhatIsThisPointButton />
            </a>
            <a target='_blank' href={downloadLink} {...getGTM(downloadGTM)}>
              <SPDownloadButton />
            </a>
          </div>

          <label className='ds-text-[11px] ds-leading-[20px] ds-mt-[8px]'>
            ※オトク継続便限定の機能やコンテンツもございます。
          </label>
        </div>
      </div>
    </Fragment>
  )
}
